import React from 'react'
import PropTypes from 'prop-types'
import SelectVehicle from '../../3_Organisms/SelectVehicle/SelectVehicle'

function SelectVehicleStep({
  title,
  handleNextStep
}) {

  const onSelectVehicle = (data) => {
    const vehicleData = {
      id: data.id,
      isEV: data.is_ev,
      title: data.carline.title,
      model: data.carline.url_slug,
      msrp: data.financial.msrp,
      year: data.year.url_slug,
      description: data.description
    }

    handleNextStep({ vehicleData: vehicleData })
  }

  return (
    <div className="mz-select-vehicle-step">
      <div className="mz-select-vehicle-step__top">
        <h5 className="mz-select-vehicle-step__title">{title}</h5>
      </div>
      <SelectVehicle onSelectVehicle={(data) => onSelectVehicle(data)} />
    </div>
  )
}

SelectVehicleStep.propTypes = {
  handleNextStep: PropTypes.func.isRequired,
  title: PropTypes.string,
}

SelectVehicleStep.defaultProps = {
  title: ''
}

export default SelectVehicleStep